import * as localForage from 'localforage'
import UniversalStorage from '@vue-storefront/core/store/lib/storage'

export function beforeRegistration({ Vue, config, store, isServer }) {
  Vue.prototype.$db.loyaltyProgramCollection = new UniversalStorage(localForage.createInstance({
    name: 'loyaltyProgram',
    storeName: 'loyalty',
    driver: localForage['LOCALSTORAGE']
  }))
}
